import { fromJS } from 'immutable';
import { COMMERCE_CART_DATA_PRODUCTS_RECEIVED, COMMERCE_CART_DATA_RECEIVED, COMMERCE_CART_TOKEN_GENERATED, COMMERCE_ORDERS_DATA_RECEIVED } from '../../actions/Commerce';
var initialState = fromJS({
  cart: {
    token: null,
    content: [],
    products: []
  },
  orders: []
});
export default function commerce() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case COMMERCE_CART_TOKEN_GENERATED:
      {
        return state.setIn(['cart', 'token'], fromJS(action.payload));
      }
    case COMMERCE_CART_DATA_RECEIVED:
      {
        return state.setIn(['cart', 'content'], fromJS(action.payload));
      }
    case COMMERCE_CART_DATA_PRODUCTS_RECEIVED:
      {
        return state.setIn(['cart', 'products'], fromJS(action.payload));
      }
    case COMMERCE_ORDERS_DATA_RECEIVED:
      {
        return state.set('orders', fromJS(action.payload));
      }
    default:
      return state;
  }
}